var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftSwich(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1101,
    height: 724,
    viewBox: "0 0 1101 724",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1082_26130)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 7.49037,
    transform: "translate(2.73047 465.002)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2207,
    y: 285.232,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 31.8341,
    transform: "translate(28.9482 339.54)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4385,
    y: 330.181,
    width: 1.87259,
    height: 54.3052,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 7.49037,
    transform: "translate(55.1641 294.594)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.6543,
    y: 272.122,
    width: 1.87259,
    height: 44.9422,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 16.8533,
    transform: "translate(343.543 185.986)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.16,
    y: 64.2667,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 218,
    width: 15,
    height: 85,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 193,
    width: 2,
    height: 132,
    rx: 1,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606,
    y: 89,
    width: 15,
    height: 96,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.324,
    y: 64.2666,
    width: 1.87259,
    height: 149,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 3.74519,
    transform: "translate(81.3799 303.958)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.8701,
    y: 285.232,
    width: 1.87259,
    height: 33.7067,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 140.444,
    transform: "translate(369.761 114.826)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.251,
    y: 103.591,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 268,
    width: 15,
    height: 164,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.335,
    y: 243.592,
    width: 1.87259,
    height: 212,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 165,
    width: 15,
    height: 168,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.416,
    y: 153.592,
    width: 1.87259,
    height: 205,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 3.74519,
    transform: "translate(107.599 277.742)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.089,
    y: 268.378,
    width: 1.87259,
    height: 26.2163,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 7.49037,
    transform: "translate(133.813 264.635)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.304,
    y: 236.545,
    width: 1.87259,
    height: 65.5408,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 20.5985,
    transform: "translate(264.894 238.419)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.386,
    y: 116.7,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 238,
    width: 15,
    height: 65,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.469,
    y: 226.7,
    width: 1.87259,
    height: 89,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 299,
    width: 15,
    height: 74,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.548,
    y: 282.647,
    width: 1.87259,
    height: 111,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658,
    y: 321,
    width: 15,
    height: 88,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.628,
    y: 303.437,
    width: 1.87259,
    height: 127,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 7.49037,
    transform: "translate(160.03 264.635)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.521,
    y: 255.271,
    width: 1.87259,
    height: 37.4519,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 16.8533,
    transform: "translate(186.246 264.636)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.864,
    y: 142.916,
    width: 1.87259,
    height: 191.005,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 16.8533,
    transform: "translate(291.113 238.419)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.731,
    y: 116.7,
    width: 1.87259,
    height: 191.005,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 155,
    width: 15,
    height: 144,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.812,
    y: 136.7,
    width: 1.87259,
    height: 191.005,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 241,
    width: 15,
    height: 52,
    rx: 2,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.767,
    y: 222.724,
    width: 1.87259,
    height: 86,
    rx: 0.936297,
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684,
    y: 235,
    width: 15,
    height: 127,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 689.975,
    y: 223.437,
    width: 1.87259,
    height: 191.005,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 56.1778,
    transform: "translate(317.327 238.419)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.945,
    y: 116.7,
    width: 1.87259,
    height: 191.005,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 186,
    width: 15,
    height: 69,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.027,
    y: 166.7,
    width: 1.87259,
    height: 110,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 157,
    width: 15,
    height: 98,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.11,
    y: 148.419,
    width: 1.87259,
    height: 126,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 711,
    y: 197,
    width: 15,
    height: 118,
    rx: 2,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718.062,
    y: 183.437,
    width: 1.87259,
    height: 154,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 14.9807,
    transform: "translate(212.463 369.5)",
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.953,
    y: 197.221,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#00AD64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.9807,
    height: 37.4519,
    transform: "translate(238.679 322.685)",
    fill: "#FE3D31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.169,
    y: 200.966,
    width: 1.87259,
    height: 209.73,
    rx: 0.936297,
    fill: "#FE3D31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1082_26130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1101,
    height: 724,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSwich);
export default __webpack_public_path__ + "static/media/left-swich.f7ecc1da890abcc3da21d8a9de533bd3.svg";
export { ForwardRef as ReactComponent };